import React from 'react'
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box,
} from '@mui/material'
import Row from './Row'
import SkeletonRow from '../shared/SkeletonRow'
import ErrorMessage from '../../shared/ErrorMessage'
import Form from './Form'
import { useGetLuckyDraws, usePostLuckyDraw } from '../../api/lucky-draw'

const LuckyDrawTable = ({ open, setOpen }) => {
  const { data = [], isLoading, refetch } = useGetLuckyDraws()
  const defaultValues = {
    companyAccountId: '',
    companyName: '',
    promotion1: 0,
    promotion2: 0,
    ticketDeducted: 0,
  }

  return (
    <Box>
      {data.length > 0 || isLoading ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Company ID</TableCell>
                <TableCell>Company Name</TableCell>
                <TableCell>Promotion 1</TableCell>
                <TableCell>Promotion 2</TableCell>
                <TableCell>Ticket Deducted</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading
                ? Array(10)
                    .fill()
                    .map((_, idx) => <SkeletonRow key={idx} height={60} />)
                : data.map((row) => {
                    return <Row data={row} key={row._id} refetch={refetch} />
                  })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <ErrorMessage empty />
      )}
      <Form
        defaultValues={defaultValues}
        open={open}
        setOpen={setOpen}
        api={usePostLuckyDraw}
        refetch={refetch}
      />
    </Box>
  )
}

export default LuckyDrawTable
